import classnames from 'clsx';
import React, { ChangeEvent, memo, MouseEvent, useCallback, useRef } from 'react';

import styles from './Switch.css';

interface Props {
    checked: boolean;
    name: string;
    value?: string;
    disabled?: boolean;
    isAwaysBlue?: boolean;
    onChange?: () => void | null;
    theme?: '' | 'rounded' | 'big';
}

export const Switch = memo<Props>(({ name, value, disabled, checked, theme, onChange, isAwaysBlue = false }) => {
    const input = useRef<HTMLInputElement>(null);

    const onClick = useCallback(
        (event: MouseEvent<HTMLDivElement> | ChangeEvent<HTMLInputElement>) => {
            if (disabled || !onChange) {
                return;
            }

            event.stopPropagation();

            onChange();
        },
        [disabled, onChange]
    );

    const className = classnames({
        [styles.base]: true,
        [styles.base_disabled]: disabled,
        [styles[`base_${theme}`]]: !!theme,
        [styles.base_checked]: checked,
        [styles.base_blue]: isAwaysBlue,
    });

    return (
        <div className={className} onClick={onClick}>
            <input
                className={styles.input}
                ref={input}
                type="checkbox"
                name={name}
                value={value}
                disabled={disabled}
                checked={checked}
                onChange={onClick}
            />
            <div className={styles.label}>
                <div className={styles.slider} />
            </div>
        </div>
    );
});

Switch.displayName = 'Switch';
